import SwitchAccount from "components/switch-account";
import React, { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "redux/hooks";
import { LOCAL_STORAGE_SELECTED_MERCHANT_ID_KEY } from "util/localStorage";
import PrivateRoute from "./PrivateRoute";
import { useMerchantResolution } from "./use-merchant-resolution";

// Routes that should adopt the last selected merchant in place rather than
// redirect to a /:merchantId URL — OAuth callbacks land back here without the
// merchant id in the path.
const IN_PLACE_ADOPTION_PATH_FRAGMENTS = [
  "callback",
  "xero",
  "quickbooks",
  "reviews/google/locations",
];

const pathAllowsInPlaceAdoption = (
  pathname: string,
  storedMerchantId: string | null
): boolean => {
  const isUnknownMerchantRoute = Boolean(
    storedMerchantId && pathname.includes(storedMerchantId)
  );
  if (isUnknownMerchantRoute) return true;

  for (const fragment of IN_PLACE_ADOPTION_PATH_FRAGMENTS) {
    if (pathname.includes(fragment)) return true;
  }

  return false;
};

const AbstractPrivateRoute = ({ children }: { children?: ReactNode }) => {
  const location = useLocation();

  const storedMerchantId = localStorage.getItem(
    LOCAL_STORAGE_SELECTED_MERCHANT_ID_KEY
  );

  const { currentAgent } = useMerchantResolution({
    candidateMerchantId: storedMerchantId
      ? parseInt(storedMerchantId, 10)
      : undefined,
    allowInPlaceAdoption: pathAllowsInPlaceAdoption(
      location.pathname,
      storedMerchantId
    ),
    persistSelectionOnAdopt: false,
    logoutOnMerchantError: false,
  });

  const { isSelectorOpened } = useAppSelector((state) => state.merchant);

  return (
    <>
      {isSelectorOpened ? null : <PrivateRoute>{children}</PrivateRoute>}
      <SwitchAccount
        required={true}
        merchants={currentAgent?.merchants || []}
      />
    </>
  );
};

export default AbstractPrivateRoute;
